import React, { useState, useRef } from 'react';
import * as XLSX from 'xlsx';
import { BASE_URL } from '../../App';
import { Box, Button, Input, Card, CardContent, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress } from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2';

const AchievementUpload = () => {
  const [excelData, setExcelData] = useState([]);
  const [chkupload, setChkupload] = useState('');
  const [showTable, setShowTable] = useState(false);
  const [isFileValid, setIsFileValid] = useState(true);
  const [open, setOpen] = useState(false);
  const fileInputRef = useRef(null);
  const login_id = localStorage.getItem("LOGIN_ID");
 

  const handleFileUpload = (e) => {
    setShowTable(false);
    setChkupload(e.target.value);
    const file = e.target.files[0];
    const fileName = file?.name.toLowerCase();

    const regex = /\.xlsx|\.xls$/;

    if (regex.test(fileName)) {
      const xlsxFlag = fileName.indexOf(".xlsx") > 0;

      if (typeof FileReader !== "undefined") {
        const reader = new FileReader();

        reader.onload = (event) => {
          const data = event.target.result;
          let workbook;

          if (xlsxFlag) {
            workbook = XLSX.read(data, { type: 'array' });
          } else {
            workbook = XLSX.read(data, { type: 'binary' });
          }

          const sheetNames = workbook.SheetNames;
          let cnt = 0;

          sheetNames.forEach((sheetName) => {
            if (cnt === 0) {
              const sheet = workbook.Sheets[sheetName];
              const excelData = XLSX.utils.sheet_to_json(sheet, { defval: '' });

              console.log('First row of Excel data:', excelData[0]);

              if (excelData.length > 0) {
                const filteredData = excelData.map((row, index) => {
                  console.log(`Row ${index + 1}:`, row);

                  return {
                      DealerCode: row['Dlr Code'] || '',  
                      SchemeId: row['SCHEME_ID'] || '',  
                      Message1: row['MESSAGE_1'] || '',
                      Message2: row['MESSAGE_2'] || '',
                      Message3: row['MESSAGE_3'] || '',
                      Message4: row['MESSAGE_4'] || '',
                      Message5: row['MESSAGE_5'] || '',
                      Message6: row['MESSAGE_6'] || '',
                  };
                });

                setExcelData(filteredData);
                setShowTable(true);
              }
              cnt++;
            }
          });
        };

        if (xlsxFlag) {
          reader.readAsArrayBuffer(file);
        } else {
          reader.readAsBinaryString(file);
        }
      } else {
        alert("Sorry! Your browser does not support HTML5!");
      }
    } else {
      setIsFileValid(false);
      setShowTable(false);
    }
  };

  const handleSave = async () => {
    try {
      setOpen(true);
  
      const dealerCode = excelData[0]?.DealerCode || '';
      const uploadapi = BASE_URL + '/dealerachievementupload';
  
      console.log('Sending data to API:', {
        dealer_code: login_id,
        achievements: excelData,
      });
  
      const response = await axios.post(uploadapi, {
        login_id: login_id,
        achievements: excelData,
      });
  
      console.log('API Response:', response);  
  
      if (response.status === 200) {
        setOpen(false);
  
        if (response.data && response.data.status_code && response.data.message) {
          console.log('Response message:', response.data.message);
       
          if (response.data.status_code == "200") {
           
            Swal.fire({
              icon: 'success',
              text: response.data.message,
              confirmButtonText: 'Okay',
            }).then(() => {
              window.location.reload();
            });
  
            setChkupload('');
           
            setExcelData([]);
            setShowTable(false);
          }
          else if (response.data.status_code == "400" ) {
            
            Swal.fire({
              icon: 'info',
              text: response.data.message,
              confirmButtonText: 'Okay',
            }).then(() => {
              window.location.reload();
            });
          }
        } else {
          console.error('Response structure is not as expected:', response.data);
          Swal.fire({
            icon: 'error',
            text: 'Unexpected response format from API.',
            confirmButtonText: 'Okay',
          });
        }
      } else {
        console.error('API did not return 200 status:', response.status);
        setOpen(false);
        Swal.fire({
          icon: 'error',
          text: 'Unexpected API error, status code: ' + response.status,
          confirmButtonText: 'Okay',
        });
      }
    } catch (error) {
      setOpen(false);
      console.error('Error uploading data:', error);
      Swal.fire({
        icon: 'error',
        text: 'Error uploading data: ' + error.message,
        confirmButtonText: 'Okay',
      });
    }
  };
  const downloadExcelTemplate = () => {
    // Define the template columns (header row)
    const templateData = [
      {
        
        "Dlr Code":'',
        "SCHEME_ID":'',
        "MESSAGE_1":'',
        "MESSAGE_2":'',
        "MESSAGE_3":'',
        "MESSAGE_4":'',
        "MESSAGE_5":'',
        "MESSAGE_6":''

      },
    ];

    // Create a worksheet from the template data
    const ws = XLSX.utils.json_to_sheet(templateData);

    // Apply styles to the header row (A1, B1, C1, etc.)
    Object.keys(ws).forEach((key) => {
      if (key.includes('1')) {  // Apply styles only to the first row (header)
        ws[key].s = {
          fill: {
            fgColor: { rgb: "1E90FF" }, // Background color (Dodger Blue)
          },
          font: {
            bold: true, // Bold text
            color: { rgb: "FFFFFF" }, // White text
          },
          alignment: {
            horizontal: "center", // Center align text horizontally
            vertical: "center", // Center align text vertically
          },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };
      }
    });

    
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Template');

   
    XLSX.writeFile(wb, 'dealer_upload_template.xlsx');
  };
  return (
    <Box display="flex" flexDirection="column" alignItems="center" sx={{ width: '100%', minHeight: '100vh', backgroundColor: '#f0f0f0', padding: 2 }}>
      <Card sx={{ width: '100%', maxWidth: '100%', padding: 3, marginTop: 3, boxShadow: 3 }}>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              backgroundColor: '#3f51b5',
              color: 'white',
              padding: '15px',
              borderRadius: '8px',
              width: '100%',
              textAlign: 'center',
              fontWeight: 'bold',
              boxShadow: 2,
            }}
          >
            Upload Dealer Achievements
          </Typography>

          <Input
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileUpload}
            inputProps={{ accept: '.xlsx, .xls' }}
            ref={fileInputRef}
            value={chkupload}
            fullWidth
            sx={{
              marginTop: 2,
              padding: '10px',
              border: '1px solid #ddd',
              borderRadius: '5px',
              '&:hover': {
                borderColor: '#3f51b5',
              },
            }}
          />

          {chkupload && (
            <Typography sx={{ marginTop: 2, textAlign: 'center', width: '200px', color: '#555' }}>
              Selected File: {chkupload.split('\\').pop()}
            </Typography>
          )}

          <Button
            variant="contained"
            color="success"
            onClick={handleSave}
            disabled={!excelData.length}
            fullWidth
            sx={{
              fontSize: '16px',
              padding: '12px',
              textTransform: 'none',
              borderRadius: '8px',
              marginTop: 3,
              width: '200px',
              '&:hover': {
                backgroundColor: '#success',
              },
            }}
          >
            {open ? <CircularProgress size={24} color="inherit" /> : 'Upload'}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={downloadExcelTemplate}
          
            fullWidth
            sx={{
              fontSize: '16px',
              padding: '12px',
              textTransform: 'none',
              borderRadius: '8px',
              marginTop: 3,
              width: '200px',
              '&:hover': {
                backgroundColor: '#303f9f',
              },
            }}
          >
            Download Template
          </Button>
        </CardContent>
      </Card>

      {showTable && excelData.length > 0 && (
        <Card sx={{ width: '100%', maxWidth: '100%', padding: 3, marginTop: 3, boxShadow: 3 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center' }}>Preview Data</Typography>
            <TableContainer component={Paper} sx={{ boxShadow: 2 }}>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: '#3f51b5', color: 'white' }}>
                    <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center' }}>Dealer Code</TableCell>
                    <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center' }}>Scheme Id</TableCell>
                    <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center' }}>Message 1</TableCell>
                    <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center' }}>Message 2</TableCell>
                    <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center' }}>Message 3</TableCell>
                    <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center' }}>Message 4</TableCell>
                    <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center' }}>Message 5</TableCell>
                    <TableCell sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center' }}>Message 6</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {excelData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ textAlign: 'center' }}>{row.DealerCode || 'N/A'}</TableCell>
                      <TableCell sx={{ textAlign: 'center' }}>{row.SchemeId || 'N/A'}</TableCell>
                      <TableCell sx={{ textAlign: 'center' }}>{row.Message1 || 'N/A'}</TableCell>
                      <TableCell sx={{ textAlign: 'center' }}>{row.Message2 || 'N/A'}</TableCell>
                      <TableCell sx={{ textAlign: 'center' }}>{row.Message3 || 'N/A'}</TableCell>
                      <TableCell sx={{ textAlign: 'center' }}>{row.Message4 || 'N/A'}</TableCell>
                      <TableCell sx={{ textAlign: 'center' }}>{row.Message5 || 'N/A'}</TableCell>
                      <TableCell sx={{ textAlign: 'center' }}>{row.Message6 || 'N/A'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default AchievementUpload;
